module.exports = __webpack_public_path__ + "img/rueckseite.73b43ae4.png";